import React from "react";
import Logo from "../Img/logo.png";
import { handleLogout } from "../Utils/auth";
import API from '../Utils/api'
import { getUsuarioFromStorage } from "../Utils/usuarioHelper";

import { Link } from "react-router-dom";
import CadastroCambista from "../Cambista/CadastroCambista";
import GerenteTemplate from './GerenteTemplate'


export class GerenciarCambistas extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        window.localStorage.setItem("returnRoute", window.location.href);
        super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
            filteredList: [],
            cambistas: []
        };
    }

    componentDidMount() {
        this.listarCambistas()
    }


    listarCambistas = async (e) => {
        const usuario = JSON.parse(localStorage.getItem("user"));
        try {
            const response = await API.post("/api/usuarios/listar-por-tutor", {
                tutorId: usuario._id
            });
            this.setState({ cambistas: response.data.sort(this.compararNome) });
            this.setState({ filteredList: this.state.cambistas })
        } catch (err) {
            console.log(err);
        }
    };

    searchName(e) {
        var filteredList = this.state.cambistas.filter(usuario => {
            if (usuario != undefined && usuario.nome.toLowerCase().includes(e.target.value.toLowerCase())) {
                return usuario;
            }
        }
        )

        this.setState({ filteredList: filteredList })
    }

    compararNome(a, b) {
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
            return 1;
        }
        if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
            return -1;
        }

        return 0
    }

    handleResetSenha = async (id) => {
        try {
            const response = await API.get(`/api/usuarios/${id}/nova-senha`)
            const { data } = response

            if (data.error) throw new Error(data.error)

            const { novaSenha, email } = data
            alert(`Anote a nova senha: ${novaSenha}, email: ${email}`)
        } catch (e) {
            console.error(e.message)
        }
    }

    handleChangeStatus = async (usuario) => {
        try {
            usuario['status'] = !usuario.status
            await API.post('/api/usuarios/update-one-user', { _id: usuario._id, status: usuario.status })
        } catch (err) {
            console.error(err)
        }
    }

    render() {
        return (
            <GerenteTemplate>

                <div className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card strpied-tabled-with-hover">
                                    <div className="card-header ">
                                        <Link to="/cadastro-cambista"
                                            className="btn btn-success btn-fill float-md-right float-lg-right">Cadastrar</Link>
                                        <h4 className="card-title">Acompanhe seus cambistas</h4>
                                        <p className="card-category">Informações dos cambistas</p>
                                    </div>
                                    <div
                                        className="card-body table-full-width table-responsive container-fluid">
                                        <div className="row pl-5 pr-5 justify-content-center">
                                            <input className="form-control w-50" placeholder="busca rapida..." onChange={this.searchName.bind(this)}></input>
                                        </div>
                                        <table className="table table-hover table-striped">
                                            <thead>
                                                <tr>
                                                    <th className="w-50">Nome</th>
                                                    <th className="w-50">Telefone</th>
                                                    <th className="w-50">Email</th>
                                                    <th className="w-auto">Status</th>
                                                    <th className="w-10"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.cambistas && this.state.filteredList.map((item, index) => {
                                                    return (
                                                        <tr key={item._id}>
                                                            <td>{item.nome}</td>
                                                            <td>{item.telefone}</td>
                                                            <td>{item.email}</td>
                                                            <td>{item.status ? 'Ativo' : 'Bloqueado'}</td>
                                                            <td className="w-100 d-flex justify-content-center">
                                                                <div className="dropdown">
                                                                    <Link to="#" id={`dLabel_${index}`}
                                                                        type="button" data-toggle="dropdown"
                                                                        aria-haspopup="true"
                                                                        aria-expanded="false">
                                                                        <i className="fas fa-ellipsis-h"></i>
                                                                    </Link>
                                                                    <div className="dropdown-menu"
                                                                        aria-labelledby={`dLabel_${index}`}>
                                                                        <Link className="dropdown-item" to={`/cadastro-cambista?id=${item._id}`} >Editar</Link>
                                                                        <Link to="#" className="dropdown-item"
                                                                            onClick={() => this.handleResetSenha(item._id)}>Redefinir
                                                                                    senha</Link>
                                                                        <Link to="#" className="dropdown-item"
                                                                            onClick={() => this.handleChangeStatus(item)}>{item.status ? 'Bloquear' : 'Ativar'}</Link>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </GerenteTemplate>
        );
    }
}

export default GerenciarCambistas;
